export default __webpack_public_path__ + "static/media/2.b63610a9.jpg";